export default __webpack_public_path__ + "static/media/ficha-grade-4.d94f48e6.webp";